import { render, staticRenderFns } from "./joinForm.vue?vue&type=template&id=eb252108&"
import script from "./joinForm.vue?vue&type=script&lang=js&"
export * from "./joinForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports